
// const originalFetch = window.fetch;

// window.fetch = async (...args) => {
//   try {
//     const response = await originalFetch(...args);

//     // ✅ Always return response (even 404/500)
//     return response;
//   } catch (error) {
//     console.error('Global fetch error:', error);

//     // Safari often throws TypeError on tab switch / backgrounding
//     const isNetworkError =
//       error instanceof TypeError || error.name === 'NetworkError';

//     if (isNetworkError) {
//       // Extra safety: only redirect if user is NOT already on /error
//       if (window.location.pathname !== '/error') {
//         // window.location.href = '/error';
//       }
//     } else {
//       // For unexpected errors, just log them (don’t redirect)
//       console.warn('Non-network fetch error ignored:', error);
//     }

//     throw error;
//   }
// };



const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    return response;

  } catch (error) {
    console.error('Global fetch error:', error);

    const requestUrl = args[0]?.url || args[0] || '';

    // Convert URL to string
    const url = String(requestUrl).toLowerCase();

    // Ignore media/static file requests
    const isMediaRequest =
      /\.(mp3|wav|ogg|m4a|aac|mp4|webm|mov|avi|mkv|png|jpg|jpeg|gif|svg|webp|ico)(\?.*)?$/.test(url);

    // Ignore media requests completely
    if (isMediaRequest) {
      console.warn('Media request failed, ignoring timeout redirect:', url);
      throw error;
    }

    const isTimeoutError =
      error?.message?.includes('Failed to fetch') ||
      error?.message?.includes('ERR_TIMED_OUT') ||
      error?.name === 'TimeoutError';

    if (isTimeoutError) {
      console.warn('Timeout error detected:', url);

      if (window.location.pathname !== '/timeout') {
        window.location.replace('/timeout');
      }

    } else if (
      error instanceof TypeError ||
      error.name === 'NetworkError'
    ) {
      console.warn('Network error detected:', url);

      if (window.location.pathname !== '/error') {
        window.location.replace('/error');
      }

    } else {
      console.warn(
        'Non-network fetch error ignored:',
        error
      );
    }

    throw error;
  }
};